import { createSlice } from '@reduxjs/toolkit';
import { Setting } from '../../models/setting.model';
interface SettingState {
    settings: Setting[];
    currentSetting: Setting | null;
    loading: boolean;
}

const initialState: SettingState = {
    settings: [],
    currentSetting: null,
    loading: false,
};

const settingSlice = createSlice({
    name: 'setting',
    initialState,
    reducers: {
        getAllSettings: (state) => {
            state.loading = true;
        },
        getAllSettingsSuccess: (state, action) => {
            state.settings = action.payload;
            state.loading = false;
        },
        getAllSettingsFailed: (state) => {
            state.loading = false;
        },
        getSettingsByCategory: (state) => {
            state.loading = true;
        },
        getSettingsByCategorySuccess: (state, action) => {
            state.settings = action.payload;
            state.loading = false;
        },
        getSettingsByCategoryFailed: (state) => {
            state.loading = false;
        },
        getSettingByKey: (state) => {
            state.loading = true;
        },
        getSettingByKeySuccess: (state, action) => {
            state.currentSetting = action.payload;
            state.loading = false;
        },
        getSettingByKeyFailed: (state) => {
            state.loading = false;
        },
        createSetting: (state) => {
            state.loading = true;
        },
        createSettingSuccess: (state, action) => {
            state.settings = [action.payload, ...state.settings];
            state.loading = false;
        },
        createSettingFailed: (state) => {
            state.loading = false;
        },
        updateSetting: (state) => {
            state.loading = true;
        },
        updateSettingSuccess: (state, action) => {
            const index = state.settings.findIndex(setting => setting.setting_key === action.payload.setting_key);
            if (index !== -1) {
                state.settings[index] = { ...state.settings[index], ...action.payload };
            }
            state.loading = false;
        },
        updateSettingFailed: (state) => {
            state.loading = false;
        },
    },
});

export const {
    getAllSettings,
    getAllSettingsSuccess,
    getAllSettingsFailed,
    getSettingsByCategory,
    getSettingsByCategorySuccess,
    getSettingsByCategoryFailed,
    getSettingByKey,
    getSettingByKeySuccess,
    getSettingByKeyFailed,
    createSetting,
    createSettingSuccess,
    createSettingFailed,
    updateSetting,
    updateSettingSuccess,
    updateSettingFailed,
} = settingSlice.actions;

export default settingSlice.reducer; 